import { patterns } from '@gem/utils';

import { IBotSymbolsHandlerOptions, ISymbolsHandler } from '../../getSymbolsChecks.types';
import { getContentPositions } from '../../utils/getContentPositions/getContentPositions';
import { isValidStartPosition } from '../../utils/isValidStartPosition/isValidStartPosition';

export const handlerBotCommands =
  ({ hasBotCommands }: IBotSymbolsHandlerOptions): ISymbolsHandler =>
  (opts) => {
    if (!hasBotCommands) {
      return;
    }

    const { text, index, symbolMatches } = opts;

    if (!isValidStartPosition({ text, index })) {
      return;
    }

    const { startPosition, content } = getContentPositions(text, index);
    const matches = content.match(patterns.BOT_COMMAND_REGEX);

    if (matches && matches[0]) {
      symbolMatches['/'].push({
        start: startPosition,
        end: startPosition + matches[0].length,
      });
    }
  };
